import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from '../../logo.png';

const servicesMenuItems = [
  { label: 'Flex Printing', key: 'flex-printing' },
  { label: 'Advertise Printing', key: 'advertise' },
  { label: 'Garments Printing', key: 'garments' },
  { label: 'Box & Bag Printing', key: 'boxbag' },
  { label: 'Multicolor Printing', key: 'multicolor' },
  { label: 'Cards Printing', key: 'cards' },
  { label: 'Business Printing', key: 'business' },
  { label: 'Other Printing', key: 'other' },
];

const mainMenuItems = [
  { label: 'Home', key: 'home' },
  { label: 'About', key: 'about' },
  { label: 'Services', key: 'services', hasDropdown: true },
  { label: 'Career', key: 'career' },
  { label: 'Blog', key: 'blog' },
  { label: 'Reviews', key: 'reviews' },
  { label: 'Contact', key: 'contact' },
];

const Header = ({ setCurrentPage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [servicesDropdownClicked, setServicesDropdownClicked] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      if (window.scrollY > 50) {
        setIsMobileMenuOpen(false);
        setShowServicesDropdown(false);
        setServicesDropdownClicked(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (page) => {
    setCurrentPage(page);
    setIsMobileMenuOpen(false);
    setShowServicesDropdown(false);
    setServicesDropdownClicked(false);
    if (page === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const toggleServicesDropdown = () => {
    setShowServicesDropdown(!showServicesDropdown);
    setServicesDropdownClicked(!servicesDropdownClicked);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.nav-item.dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        setShowServicesDropdown(false);
        setServicesDropdownClicked(false);
      }
    };
    if (showServicesDropdown && servicesDropdownClicked) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showServicesDropdown, servicesDropdownClicked]);

  const handleMouseEnter = () => {
    if (!servicesDropdownClicked) {
      setShowServicesDropdown(true);
    }
  };

  const handleMouseLeave = () => {
    if (!servicesDropdownClicked) {
      setShowServicesDropdown(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`} role="banner">
      <div className="container">
        <nav className="navbar" role="navigation" aria-label="Primary Navigation">
          <div
            className="logo"
            onClick={() => handleNavigation('home')}
            style={{ cursor: 'pointer' }}
            tabIndex={0}
            aria-label="Homepage"
          >
            <img src={logo} alt="Gyaniraj Offset Logo" className="logo-img" />
            <span className="tagline">Since 2013</span>
          </div>

          <ul className="nav-menu">
            {mainMenuItems.map((item) => (
              <li
                className={`nav-item ${item.hasDropdown ? 'dropdown' : ''}`}
                key={item.key}
                onMouseEnter={item.hasDropdown ? handleMouseEnter : undefined}
                onMouseLeave={item.hasDropdown ? handleMouseLeave : undefined}
              >
                {!item.hasDropdown ? (
                  <button
                    className="nav-link"
                    onClick={() => handleNavigation(item.key)}
                    aria-current={item.key === 'home' ? 'page' : undefined}
                  >
                    {item.label}
                  </button>
                ) : (
                  <>
                    <button
                      className="nav-link dropdown-toggle"
                      onClick={toggleServicesDropdown}
                      aria-expanded={showServicesDropdown}
                      aria-haspopup="true"
                    >
                      {item.label}
                    </button>
                    {showServicesDropdown && (
                      <ul className="submenu" role="menu">
                        {servicesMenuItems.map((service) => (
                          <li key={service.key} role="none">
                            <button
                              className="submenu-link"
                              role="menuitem"
                              onClick={() => handleNavigation(service.key)}
                            >
                              {service.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </li>
            ))}
          </ul>

          <button
            className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </nav>

        {isMobileMenuOpen && (
          <div className="mobile-menu-overlay" id="mobile-menu">
            <ul className="mobile-nav-menu">
              {mainMenuItems.map((item) =>
                !item.hasDropdown ? (
                  <li className="mobile-nav-item" key={item.key}>
                    <button className="mobile-nav-link" onClick={() => handleNavigation(item.key)}>
                      {item.label}
                    </button>
                  </li>
                ) : (
                  <li className="mobile-nav-item" key={item.key}>
                    <button
                      className="mobile-nav-link"
                      onClick={() => setShowServicesDropdown(!showServicesDropdown)}
                      aria-expanded={showServicesDropdown}
                      aria-controls="mobile-submenu"
                    >
                      {item.label}
                    </button>
                    {showServicesDropdown && (
                      <ul className="mobile-submenu" id="mobile-submenu">
                        {servicesMenuItems.map((service) => (
                          <li key={service.key}>
                            <button className="mobile-submenu-link" onClick={() => handleNavigation(service.key)}>
                              {service.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
